import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { Rating } from 'src/features/product-card/NerdWalletRating/Rating';
import { StarRatingTooltip } from 'src/features/product-card/NerdWalletRating/StarRatingTooltip';
export default function ReviewProductCardRating() {
  const $ = _c(22);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    starRating,
    details: t1
  } = t0;
  const {
    isMonetizing
  } = t1;
  if (!starRating) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "row",
      height: "1.7rem"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      mr: 2,
      mt: 0.25
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontWeight: "450",
      fontSize: "32px",
      lineHeight: "32px",
      alignSelf: "center"
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== starRating) {
    t6 = starRating.toFixed(1);
    $[4] = starRating;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <Box sx={t4}><Typography sx={t5} data-testid="btmLineRatingNumber">{t6}</Typography></Box>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignSelf: "center",
      marginRight: "2px"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== starRating) {
    t9 = <Rating value={starRating} size="22px" gap="7px" additionalStyles={t8} />;
    $[9] = starRating;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t9) {
    t10 = <Box sx={t3}>{t7}{t9}</Box>;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      display: "flex",
      alignItems: "center",
      justifyContent: {
        xs: "flex-start",
        sm: "center"
      },
      whiteSpace: "nowrap"
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Box><Typography variant="overline" sx={{
        pr: 1,
        color: "neutral.darker",
        letterSpacing: "0.05rem"
      }}>NerdWallet rating</Typography></Box>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      mt: 0.5
    };
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== isMonetizing) {
    t14 = <Box sx={t11}>{t12}<Box sx={t13}><StarRatingTooltip isMonetizing={isMonetizing} maxWidth="17.25rem" segmentActionSection="marketplace_comparison_table_product" /></Box></Box>;
    $[17] = isMonetizing;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t10 || $[20] !== t14) {
    t15 = <Box sx={t2}>{t10}{t14}</Box>;
    $[19] = t10;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
}